import type { IconComponent } from '@/modules/common/types/icon.type';

export class Card {
  id: number;
  title: string;
  icon: IconComponent;
  subtitle?: string;

  constructor(
    response: Record<string, unknown>,
    idKey: string,
    titleKey: string,
    icon: IconComponent,
    subtitleKey?: string
  ) {
    this.id = response[idKey] as number;
    this.title = response[titleKey] as string;
    this.icon = icon;

    if (subtitleKey) {
      this.subtitle = response[subtitleKey] as string;
    }
  }
}
